export default "__VITE_ASSET__DgaMUUsU__"